'use strict';

window._theme = window._theme || {};

class ViewTrack {
  constructor() {
    window.dataLayer = window.dataLayer || [];
    this.isMobile = window.innerWidth < 1025 ? true : false;
    this.countryCode = localStorage.getItem('shopCountryCode') || window.Shopify?.country || 'US';
    this.formattedItemId = true;
  }

  init = () => {
    this.buildSelectors();
    this.initViewTrackEvents();
    this.initClickTrackEvent();
    // this.initHoverTrackEvent();
    this.init404PageTrackEvent();
    this.initQuickViewTrackEvents();
    this.initBuyItNowTrackEvent();
    this.initQuickViewClickTrackEvent();
    this.initSeeProductDetailsTrackEvent();
    this.initNavClickTrackEvent();
  };

  initOnLoad = () => {
    const listrakModalBtn = document.getElementById('ltkPopupTriggerButton');
    if (listrakModalBtn) this.trackView('Listrak newsletter model');
  };

  buildSelectors = () => {
    this.selectors = {};

    const pdpOfferLabelElem =
      document.querySelector('.product-shop [id*=pdp_label_] .bogopromoTitle') ||
      document.querySelector('.product-shop [id*=pdp_label_]');

    this.selectors.trackElements = [
      {
        elems: Array.from(document.querySelectorAll('#shopify-section-announcement-bar a')),
        msg: 'Announcement-bar',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      {
        elems: Array.from(document.querySelectorAll('.section_hero-banner .card-img-text')),
        msg: 'Hero banner',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      {
        elem: document.querySelector(
          '.shopify-section.section_top-brands .card--default .explore-card-wrapper'
        ),
        msg: 'Brands slider',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      // {
      //   elems: Array.from(document.querySelectorAll('.shopify-section.home-feature-product-sections [data-featured-products] .image-with-text-card-item-link')),
      //   msg: null,
      //   defaultMsg: "Banner View",
      //   trackView: true,
      //   trackClick: false,
      //   trackMouseHover: false,
      //   async: true
      // },
      {
        elems: Array.from(
          document.querySelectorAll(
            '.shopify-section.section_top-brands .card-vertical .explore-card'
          )
        ),
        msg: 'Home collection',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      {
        elems: Array.from(
          document.querySelectorAll('.shopify-section.section_featured-categories .category-link')
        ),
        msg: null,
        prefix: 'Home featured collection',
        defaultMsg: 'Home featured collection',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      {
        elem: document.querySelector('.shopify-section.home-blog-posts-sections'),
        msg: 'Home blog',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      {
        elems: Array.from(document.querySelectorAll('.template-collection .sidebar-banner a, .sidebar-banner a')),
        msg: 'Collection side-banner',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      {
        elems: Array.from(
          document.querySelectorAll(
            '.template-collection .product-collection .pro-bann-grid .promo_banner a, .pro-bann-grid .promo_banner a'
          )
        ),
        msg: 'Collection product grid banner',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      {
        elem: pdpOfferLabelElem,
        msg: pdpOfferLabelElem?.textContent?.trim(),
        defaultMsg: 'PDP Offer Label',
        trackView: true,
        trackClick: true,
        trackMouseHover: false,
      },
      // {
      //   elems: Array.from(document.querySelectorAll('.inner.product-item .quickview-button')),
      //   msg: "Quickview",
      //   trackView: false,
      //   trackClick: false,
      //   trackMouseHover: true
      // }
    ];
  };

  initViewTrackEvents = () => {
    const callbackFn = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const target = entry.target;
          try {
            const eventText = this.getEventText(target);
            this.trackView(eventText);
            observer.unobserve(target);
          } catch (error) {
            observer.unobserve(target);
          }
        }
      });
    };

    const observerIns = new IntersectionObserver(callbackFn, {
      root: null,
      rootMargin: '0px 0px 0px 0px',
      threshold: 0.8,
    });

    this.selectors.trackElements.forEach((item) => {
      if (!item.trackView) return;

      if (item.elem) observerIns.observe(item.elem);
      if (item.elems) {
        item.elems.forEach((itemElem) => {
          observerIns.observe(itemElem);
        });
      }
    });
  };

  initClickTrackEvent = () => {
    this.selectors.trackElements.forEach((item) => {
      if (!item.trackClick) return;

      if (item.elem) {
        item.elem.addEventListener('click', (evt) => {
          this.handleTrackClick(evt, item.elem, item);
        });
      }

      if (item.elems) {
        item.elems.forEach((itemElem) => {
          itemElem.addEventListener('click', (evt) => {
            this.handleTrackClick(evt, itemElem, item);
          });
        });
      }
    });

    // Event Delegation for dynamically loaded promo banners in the product grid
    document.addEventListener('click', (evt) => {
      const bannerLink = evt.target.closest('.pro-bann-grid a, .promo_banner a');
      if (bannerLink && !bannerLink.closest('.site-nav')) { // Avoid interfering with nav banners if any
        const item = {
          msg: 'Collection product grid banner',
          trackView: true,
          trackClick: true,
          trackMouseHover: false,
        };
        this.handleTrackClick(evt, bannerLink, item);
      }
    });
  };

  initHoverTrackEvent = () => {
    if (this.isMobile) return;

    this.selectors.trackElements.forEach((item) => {
      if (!item.trackMouseHover || !item.elems || item.elems.length === 0) return;

      let timer;
      item.elems.forEach((elem) => {
        elem.addEventListener('mouseenter', (evt) => {
          timer = setTimeout(() => {
            this.trackView(item.msg);
          }, 300);
        });

        elem.addEventListener('mouseleave', (evt) => {
          clearTimeout(timer);
        });
      });
    });
  };

  initNavClickTrackEvent = () => {
    // Both desktop and mobile nav containers
    const navs = document.querySelectorAll('[data-nav-container]');
    if (!navs.length) return;

    navs.forEach((nav) => {
      nav.addEventListener('click', (evt) => {
        const target = evt.target.closest('a');
        if (!target) return;

        const href = target.getAttribute('href');
        // Ignore dummy links that are used for toggling menus
        if (!href || href === '#' || href === 'javascript:void(0)' || href.startsWith('javascript:')) {
          return;
        }

        let nav_parent = '';
        let nav_section = '';
        let nav_item = '';
        let nav_position = '';

        // 1. Resolve Top Level Parent (using data-nav-lv1)
        const lv1Li = target.closest('[data-nav-lv1]');
        if (lv1Li) {
          const lv1Link = lv1Li.querySelector('a');
          if (lv1Link) {
            nav_parent = (lv1Link.querySelector('[data-nav-title]')?.textContent || lv1Link.textContent).replace(/\s+/g, ' ').trim();
          }
        }

        // 2. Resolve Item Hierarchy (using data-nav-* attributes)
        const lv3Li = target.closest('[data-nav-lv3]');
        const lv2Div = target.closest('[data-nav-lv2]');
        const bannerLink = target.closest('[data-nav-banner]');
        const style1BrandContent = target.closest('[data-nav-style1-brands]');
        const style1FeaturedContent = target.closest('[data-nav-style1-featured]');

        if (bannerLink) {
          // Mega menu promotional banners
          const bannerHead = target.closest('[data-nav-banner-col]')?.querySelector('[data-nav-banner-head]');

          nav_item = (bannerLink.querySelector('[data-nav-title]')?.textContent || bannerLink.getAttribute('aria-label') || '').replace(/\s+/g, ' ').trim();
          nav_section = bannerHead ? bannerHead.textContent.replace(/\s+/g, ' ').trim() : 'Highlight Categories';
          nav_position = Array.from(bannerLink.parentNode.querySelectorAll('[data-nav-banner]')).indexOf(bannerLink) + 1;
        } else if (style1BrandContent) {
          // Style 1 (Brands A-Z)
          const menuWrapper = style1BrandContent.closest('.block-style-1') || style1BrandContent.closest('.container');
          const activeBtn = menuWrapper?.querySelector('[data-nav-alpha-btn].active');
          const activeLetter = activeBtn?.getAttribute('data-letter')?.toUpperCase();
          const sectionTitleElem = menuWrapper?.querySelector('[data-nav-section-title]');
          const sectionTitle = (sectionTitleElem?.getAttribute('aria-label') || sectionTitleElem?.textContent || 'Brands A - Z').replace(/\s+/g, ' ').trim();

          nav_item = target.textContent.replace(/\s+/g, ' ').trim();
          nav_section = activeLetter ? `${sectionTitle} (${activeLetter})` : sectionTitle;

          const li = target.closest('li');
          nav_position = li ? Array.from(li.parentNode.querySelectorAll('li')).indexOf(li) + 1 : '';
        } else if (style1FeaturedContent) {
          // Style 1 (Featured Brands)
          const menuWrapper = style1FeaturedContent.closest('.block-style-1') || style1FeaturedContent.closest('.container');
          const sectionTitleElem = menuWrapper?.querySelector('.featured-brands-btm-btn[data-nav-section-title]');
          const sectionTitle = (sectionTitleElem?.getAttribute('aria-label') || sectionTitleElem?.textContent || 'Featured Brands').replace(/\s+/g, ' ').trim();

          nav_item = (target.getAttribute('aria-label') || target.textContent).replace('view all products from ', '').replace(/\s+/g, ' ').trim();
          nav_section = sectionTitle;

          const item = target.closest('.item');
          nav_position = item ? Array.from(style1FeaturedContent.querySelectorAll('.item')).indexOf(item) + 1 : '';
        } else if (lv3Li) {
          // Standard Level 3 Links
          nav_item = target.textContent.replace(/\s+/g, ' ').trim();

          if (lv2Div) {
            const lv2Heading = lv2Div.querySelector('[data-nav-heading]') || lv2Div.querySelector('[role="heading"]') || lv2Div.querySelector('a, span');
            nav_section = lv2Heading ? lv2Heading.textContent.replace(/\s+/g, ' ').trim() : '';
          }

          nav_position = Array.from(lv3Li.parentNode.querySelectorAll('[data-nav-lv3]')).indexOf(lv3Li) + 1;
        } else if (lv2Div) {
          // Standard Level 2 Links/Sections
          nav_item = target.textContent.replace(/\s+/g, ' ').trim();
          nav_section = nav_item;

          nav_position = Array.from(lv2Div.parentNode.querySelectorAll('[data-nav-lv2]')).indexOf(lv2Div) + 1;
        } else if (target === lv1Li?.querySelector('a')) {
          // Top level link itself clicked
          nav_parent = target.textContent.replace(/\s+/g, ' ').trim();
          nav_section = '';
          nav_item = '';
          nav_position = '';
        }

        this.trackNavClick({
          nav_url: target.href,
          nav_parent,
          nav_section,
          nav_item,
          nav_position,
        });
      });
    });
  };

  trackNavClick = (data) => {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'nav_click',
        ...data,
      });
    } catch (error) {
      console.warn('Error while tracking navigation click:', error);
    }
  };

  init404PageTrackEvent = () => {
    const body = document.body;
    if (!body || body.getAttribute('data-template') !== '404') return;

    setTimeout(() => {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: '404_page',
        pageUrl: window.location.href,
        pageReferrer: document.referrer || 'Direct',
      });
    }, 300);
  };

  initQuickViewTrackEvents = () => {
    // Track "View More" button clicks in quick view
    document.addEventListener('click', (event) => {
      const viewMoreButton = event.target.closest('[data-quickview-view-more]');
      if (viewMoreButton) {
        const data = this.extractQuickViewData(viewMoreButton);
        this.trackQuickViewSelectItem(data);
      }
    });

    // Track "Add to Cart" button clicks in quick view
    document.addEventListener('click', (event) => {
      const addToCartButton = event.target.closest('[data-quickview-add-to-cart]');
      if (addToCartButton) {
        const data = this.extractQuickViewData(addToCartButton);
        this.trackQuickViewAddToCart(data);
      }
    });
  };

  initBuyItNowTrackEvent = () => {
    // Capture phase so isBuyNowClick is set before product-form / cart / datalayer handlers
    document.addEventListener(
      'click',
      (evt) => {
        const button = evt.target.closest('[name="custom_checkout"], [data-buy-now-btn]');
        if (!button) return;

        window._theme = window._theme || {};
        window._theme.isBuyNowClick = true;

        this.trackBuyItNowClick(button.closest('form'), button);
      },
      true
    );
  };

  trackBuyItNowClick = (form, button) => {
    if (!form || !button) return;

    const variantId = form.querySelector('[name="id"]')?.value ||
    document.querySelector(`[name="id"][form="${form.id}"]`)?.value || '';
    const qtyField = document.querySelector(`[name="quantity"][form="${form.id}"]`) ||
    form.querySelector('[name="quantity"]');
    const quantity = parseInt(qtyField?.value, 10) || 1;

    try {
      let product = {};
      const scope = form.closest('.product, .quickview-tpl, [data-quickview-modal], [data-product-card-quickview-html], quickview-dialog');
      const json = scope?.getAttribute('data-product-json') || scope?.querySelector('script[data-product-json]')?.textContent || document.getElementById('variants_data')?.textContent;
      if (json) product = typeof json === 'string' ? JSON.parse(json) : json;
      const variants = Array.isArray(product) ? product : (product.variants || []);
      const variant = variants.find((v) => String(v.id) === String(variantId)) || product.selected_or_first_available_variant || {};
      const rawPrice = variant.price != null ? variant.price : (product.price || 0);
      const rawComparePrice = variant.compare_at_price != null ? variant.compare_at_price : (product.compare_at_price || 0);
      const price = rawPrice > 1000 && String(rawPrice).indexOf('.') === -1 ? rawPrice / 100 : Number(rawPrice);
      const compareAtPrice = rawComparePrice > 1000 && String(rawComparePrice).indexOf('.') === -1 ? rawComparePrice / 100 : Number(rawComparePrice);
      const discount = compareAtPrice > price ? +(compareAtPrice - price).toFixed(2) : 0;
      const productId = String(product.id || '');
      const vId = String(variantId || variant.id || productId);
  
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'buy_it_now_click',
        click_text: 'Buy It Now',
        page_path: window.location.pathname,
        page_location: window.location.href,
        cta_location: form.closest('[data-quickview-modal], .quickview-tpl, quickview-dialog, [data-product-card-quickview-html]') ? 'quick view' : 'product page',
        ecommerce: {
          currency: window.Shopify?.currency?.active || 'USD',
          value: Number((price * quantity).toFixed(2)),
          items: [
            {
              item_id: this.formattedItemId ? `shopify_${this.countryCode}_${productId}_${vId}` : productId,
              product_id: productId,
              variant_id: vId,
              item_name: product.title || '',
              quantity,
              price: +price.toFixed(2),
              discount: discount,
              item_brand: product.vendor || '',
              item_list_name: product.type || product.product_type || '',
              item_list_id: String(product.collection_id || ''),
            },
          ],
        },
      });
    } catch (e) {
      console.error("Error:", e.message);
    }
  };

  initSeeProductDetailsTrackEvent = () => {
    document.addEventListener('click', (evt) => {
      const link = evt.target.closest('a.quickview-dialog__details-link');
      if (!link) return;
      this.trackSeeProductDetails(link);
    });
  };

  trackSeeProductDetails = (link) => {
    try {
      let product = {};
      const scope = link.closest('[data-product-card-quickview-html], [data-quickview-modal], .quickview-tpl, quickview-dialog');
      const json = scope?.querySelector('script[data-product-json]')?.textContent;
      if (json) product = JSON.parse(json);
      const variants = Array.isArray(product) ? product : (product.variants || []);
      const currentVariant = product.selected_or_first_available_variant || variants[0] || {};
  
      const rawPrice = currentVariant.price != null ? currentVariant.price : (product.price || 0);
      const rawComparePrice = currentVariant.compare_at_price != null ? currentVariant.compare_at_price : (product.compare_at_price || 0);
      const price = rawPrice > 1000 && String(rawPrice).indexOf('.') === -1 ? rawPrice / 100 : Number(rawPrice);
      const compareAtPrice = rawComparePrice > 1000 && String(rawComparePrice).indexOf('.') === -1 ? rawComparePrice / 100 : Number(rawComparePrice);
      const discount = compareAtPrice > price ? +(compareAtPrice - price).toFixed(2) : 0;
      const productId = String(product.id || '');
      const variantId = String(currentVariant.id || productId);
  
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'see_product_details',
        click_text: 'See product details',
        page_path: window.location.pathname,
        page_location: window.location.href,
        ecommerce: {
          currency: window.Shopify?.currency?.active || 'USD',
          value: +price.toFixed(2),
          items: [
            {
              item_id: this.formattedItemId ? `shopify_${this.countryCode}_${productId}_${variantId}` : productId,
              product_id: productId,
              variant_id: variantId,
              item_name: product.title || '',
              quantity: 1,
              price: +price.toFixed(2),
              discount: discount,
              item_brand: product.vendor || '',
              item_list_name: product.type || product.product_type || '',
              item_list_id: String(product.collection_id || ''),
            },
          ],
        },
      });
    } catch (e) {
      console.error("Error:", e.message);
    }
  };

  initQuickViewClickTrackEvent = () => {

    document.addEventListener(
      'click',
      (evt) => {
        const button = evt.target.closest('button.product-card__quickview, button.product-card__quickview_eye');
        if (!button) return;

        this.trackQuickViewClick(button);
      },
      true
    );
  };

  trackQuickViewClick = (button) => {
    let item = {};
    try {
      const script = button.parentElement?.querySelector('script[data-product-json]') || button.closest('article.product-card, .inner.product-item')?.querySelector('script[data-product-json]');
      if (script) item = JSON.parse(script.textContent);
      const productId = String(item.product_id || item.id || '');
      const variantId = String(item.variant_id || '');
      const rawPrice = item.final_price != null ? item.final_price : (item.price != null ? item.price : 0);
      const price = rawPrice > 1000 && String(rawPrice).indexOf('.') === -1 ? +(rawPrice / 100).toFixed(2) : +Number(rawPrice).toFixed(2);
      const rawCompare = item.compare_at_price != null ? item.compare_at_price : (item.compareAtPrice != null ? item.compareAtPrice : 0);
      const comparePrice = rawCompare > 1000 && String(rawCompare).indexOf('.') === -1 ? rawCompare / 100 : Number(rawCompare);
      const discount = item.total_discount != null ? (item.total_discount > 1000 && String(item.total_discount).indexOf('.') === -1 ? +(item.total_discount / 100).toFixed(2) : +Number(item.total_discount).toFixed(2)) : (comparePrice > price ? +(comparePrice - price).toFixed(2) : (item.discount ? +Number(item.discount).toFixed(2) : 0));
  
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'quick_view',
        click_text: 'Quick View',
        page_path: window.location.pathname,
        page_location: window.location.href,
        ecommerce: {
          currency: window.Shopify?.currency?.active || 'USD',
          value: price,
          items: [
            {
              item_id: this.formattedItemId ? `shopify_${this.countryCode}_${productId}_${variantId}` : productId,
              product_id: productId,
              variant_id: variantId,
              item_name: item.product_title || item.title || '',
              quantity: 1,
              price: price,
              discount: discount,
              item_brand: item.vendor || '',
              item_list_name: item.product_type || item.type || '',
              item_list_id: String(item.item_list_id || item.collection_id || ''),
            },
          ],
        },
      });
    } catch (e) {
      console.error("Error:", e.message);
    }

  };

  extractQuickViewData = (button) => {
    // Get current quantity from the form
    const form = button.closest('form');
    const quantityInput = form?.querySelector(
      'input[name="quantity"], .quantity__select, [data-quantity]'
    );
    const currentQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;

    // Get data from product container
    const productContainer = document.querySelector('.product');
    let currentVariant = null;
    let productData = null;

    if (productContainer) {
      // Get full product data from product container
      const productJson = productContainer.getAttribute('data-product-json');
      if (productJson) {
        try {
          productData = JSON.parse(productJson);

          // Get current variant from updated data (set by onVariantChange)
          const currentVariantJson = productContainer.getAttribute('data-current-variant');
          if (currentVariantJson) {
            try {
              currentVariant = JSON.parse(currentVariantJson);
            } catch (e) {
              console.warn('Failed to parse current variant JSON:', e);
            }
          }

          // Fallback: use initial variant from product data
          if (!currentVariant && productData && productData.selected_or_first_available_variant) {
            currentVariant = productData.selected_or_first_available_variant;
          }
        } catch (e) {
          console.warn('Failed to parse product JSON:', e);
        }
      }
    }

    const data = {
      productId: productData ? productData.id : null,
      productTitle: productData ? productData.title : null,
      productVendor: productData ? productData.vendor : null,
      productType: productData ? productData.type : null,
      variantId: currentVariant ? currentVariant.id : null,
      variantTitle: currentVariant ? currentVariant.title : null,
      price: currentVariant ? (currentVariant.price / 100).toString() : null,
      currency: 'USD',
      collectionTitle: button.getAttribute('data-collection-title'),
      collectionHandle: button.getAttribute('data-collection-handle'),
      productPosition:
        window.currentQuickViewGridIndex !== null ? window.currentQuickViewGridIndex : 0,
      quantity: currentQuantity,
      compareAtPrice: currentVariant
        ? currentVariant.compare_at_price
          ? (currentVariant.compare_at_price / 100).toString()
          : 0
        : 0,
    };

    return data;
  };

  handleTrackClick = (evt, targetElem, item) => {
    const eventTarget =
      evt.target.nodeName === 'A'
        ? evt.target
        : evt.target.closest('a')
          ? evt.target.closest('a')
          : evt.target;

    let eventText = this.getEventText(targetElem);
    if ((!eventText || eventText === 'Banner Click') && item && item.msg) {
      eventText = item.msg;
    }

    const linkTag =
      eventTarget.nodeName === 'A'
        ? eventTarget
        : targetElem.nodeName === 'A'
          ? targetElem
          : targetElem.closest('a');
    const clickedUrl = linkTag ? linkTag.href : '';

    // Extract text and collapse all newlines/multiple spaces into a single space
    const img = targetElem.querySelector('img') || evt.target.querySelector('img') || (evt.target.nodeName === 'IMG' ? evt.target : null);
    const rawText = targetElem.textContent?.trim() || evt.target.textContent?.trim() || (img ? img.alt : '') || targetElem.getAttribute('aria-label') || '';
    const clickedText = rawText.replace(/\s+/g, ' ').trim();

    this.trackClick(eventText, 0, clickedUrl, clickedText);

    if (!linkTag) return;

    setTimeout(() => {
      window.location.href = linkTag.href;
    }, 250);
  };

  /**
   * @param {string} title
   * @param {number} index
   * @returns void
   */
  trackView = (title, index) => {
    if (!title) return;

    try {
      window.dataLayer.push({
        event: 'banner_view',
        banner_name: title,
        banner_index: index || 0,
      });
    } catch (error) {
      console.warn('Error while tracking view');
    }
  };

  /**
   * @param {string} title
   * @param {number} index
   * @param {string} clickedUrl
   * @param {string} clickedText
   * @returns void
   */
  trackClick = (title, index, clickedUrl, clickedText) => {
    if (!title) return;

    try {
      const payload = {
        event: 'banner_click',
        bannername_: title,
        bannerindex: index || 0,
        clicked_url: clickedUrl || '',
        clicked_text: clickedText || '',
      };

      window.dataLayer.push(payload);
    } catch (error) {
      console.warn('Error while tracking click');
    }
  };

  /**
   * @param {{productTitle: string, variantTitle: string, variantPrice: number}} data
   * @returns void
   */
  trackQuickView = (data) => {
    if (!data.productTitle || !data.variantTitle || !data.variantPrice) return;

    window.dataLayer.push({
      event: 'Quickview ATC',
      product_name: data.productTitle,
      product_variant: data.variantTitle,
      product_price: data.variantPrice,
    });
  };

  /**
   * Track quick view "View More" button click (select_item_quick_view event)
   */
  trackQuickViewSelectItem = (data) => {
    if (!data.productId || !data.productTitle) return;

    try {
      // Parse and validate prices
      const price = parseFloat(data.price) || 0;
      const compareAtPrice = parseFloat(data.compareAtPrice) || 0;

      // Calculate discount only if compare_at_price is greater than current price
      const discount =
        compareAtPrice > 0 && compareAtPrice > price
          ? parseFloat((compareAtPrice - price).toFixed(2))
          : 0;

      const eventData = {
        event: 'select_item_quick_view',
        ecommerce: {
          item_list_id: data.collectionHandle,
          item_list_name: data.collectionTitle,
          items: [
            {
              item_id: data.productId,
              item_name: data.productTitle,
              item_brand: data.productVendor,
              item_category: data.productType,
              item_category2: '',
              item_category3: '',
              item_variant: data.variantTitle,
              price: price,
              discount: discount,
              currency: data.currency,
              index: data.productPosition || 1,
              item_list_id: data.collectionHandle,
              item_list_name: data.collectionTitle,
            },
          ],
        },
      };

      window.dataLayer.push(eventData);
    } catch (error) {
      console.warn('Error while tracking quick view select item:', error);
    }
  };

  /**
   * Track quick view "Add to Cart" button click (add_to_cart_quick_view event)
   */
  trackQuickViewAddToCart = (data) => {
    if (!data.productId || !data.productTitle) return;

    try {
      // Parse and validate prices
      const price = parseFloat(data.price) || 0;
      const quantity = parseInt(data.quantity) || 1;

      // Calculate total value with proper rounding
      const totalValue = parseFloat((price * quantity).toFixed(2));

      const eventData = {
        event: 'add_to_cart_quick_view',
        ecommerce: {
          currency: data.currency,
          value: totalValue,
          items: [
            {
              item_id: data.productId,
              item_name: data.productTitle,
              item_brand: data.productVendor,
              item_category: data.productType,
              item_category2: '',
              item_category3: '',
              item_variant: data.variantTitle,
              price: price,
              quantity: quantity,
              index: data.productPosition !== null ? data.productPosition : 0,
              item_list_id: data.collectionHandle,
              item_list_name: data.collectionTitle,
            },
          ],
        },
      };

      window.dataLayer.push(eventData);
    } catch (error) {
      console.warn('Error while tracking quick view add to cart:', error);
    }
  };

  /**
   * Track quick view "Buy Now" button click (buy_now_quick_view event)
   */
  trackQuickViewBuyNow = (data) => {
    if (!data.productId || !data.productTitle) return;

    try {
      // Parse and validate prices
      const price = parseFloat(data.price) || 0;
      const quantity = parseInt(data.quantity) || 1;

      // Calculate total value with proper rounding
      const totalValue = parseFloat((price * quantity).toFixed(2));

      const eventData = {
        event: 'buy_now_quick_view',
        ecommerce: {
          currency: data.currency,
          value: totalValue,
          items: [
            {
              item_id: data.productId,
              item_name: data.productTitle,
              item_brand: data.productVendor,
              item_category: data.productType,
              item_category2: '',
              item_category3: '',
              item_variant: data.variantTitle,
              price: price,
              quantity: quantity,
              index: data.productPosition !== null ? data.productPosition : 0,
              item_list_id: data.collectionHandle,
              item_list_name: data.collectionTitle,
            },
          ],
        },
      };

      window.dataLayer.push(eventData);
    } catch (error) {
      console.warn('Error while tracking quick view buy now:', error);
    }
  };

  /**
   * Track quick view button click (quick_view event)
   */
  trackQuickViewOpen = (data) => {
    if (!data.productId || !data.productTitle) return;

    try {
      // Parse and validate prices
      const price = parseFloat(data.price) || 0;
      const compareAtPrice = parseFloat(data.compareAtPrice) || 0;

      // Calculate discount only if compare_at_price is greater than current price
      const discount =
        compareAtPrice > 0 && compareAtPrice > price
          ? parseFloat((compareAtPrice - price).toFixed(2))
          : 0;

      const eventData = {
        event: 'quick_view',
        ecommerce: {
          item_list_id: data.collectionHandle,
          item_list_name: data.collectionTitle,
          items: [
            {
              item_id: data.productId,
              item_name: data.productTitle,
              item_brand: data.productVendor,
              item_category: data.productType,
              item_category2: '',
              item_category3: '',
              item_variant: data.variantTitle,
              price: price,
              discount: discount,
              currency: data.currency,
              index: data.productPosition !== null ? data.productPosition : 0,
              item_list_id: data.collectionHandle,
              item_list_name: data.collectionTitle,
            },
          ],
        },
      };

      window.dataLayer.push(eventData);
    } catch (error) {
      console.warn('Error while tracking quick view open:', error);
    }
  };

  /**
   *
   * @param {string} event
   * @param {string} method
   */
  trackEvent = (event, method) => {
    if (!event || !method) return;

    window.dataLayer.push({
      event: event,
      method: method,
    });
  };

  trackData = (data = {}) => {
    if (!data) return;

    window.dataLayer.push({
      ...data,
    });
  };

  getTargetConfig(target) {
    if (!target) return null;

    let targetIndex = 0;
    const targetTrackType = target.dataset.trackType;

    const item = this.selectors.trackElements.find((item) => {
      if (item.elem) return item.elem === target;

      if (item.elems)
        return item.elems.find((elem, index) => {
          const trackType = elem.dataset.trackType;
          if (targetTrackType && trackType && targetTrackType === trackType) targetIndex += 1;
          if (elem === target) {
            targetIndex = targetIndex != 0 ? targetIndex : index + 1;
            return true;
          }

          return false;
        });
    });

    if (item) item['targetIndex'] = targetIndex;

    return item;
  }

  getEventText(target) {
    let eventText;
    const item = this.getTargetConfig(target);
    if (!item) return target.textContent?.trim() || target.getAttribute('aria-label') || 'Banner Click';
    if (item.prefix) {
      const type = target.dataset.trackType;
      item.msg = type ? `${item.prefix}:${type}:` : item.prefix;
    }
    eventText =
      (item.targetIndex && item.elems && item.elems.length > 1) !== 0
        ? `${item.msg} ${item.targetIndex}`
        : item.msg;
    if (!item.msg)
      eventText =
        target.textContent?.trim() || target.getAttribute('aria-label') || item.defaultMsg;

    return eventText || 'Banner Click';
  }
}

_theme.track = new ViewTrack();

document.addEventListener('DOMContentLoaded', function (event) {
  _theme.track.init();
});

window.onload = function () {
  _theme.track.initOnLoad();
};
